import { Col, Row } from 'antd'
import AntdInput from 'components/Form/Input'
import Switch from 'components/Form/Switch'
import 'draft-js/dist/Draft.css'
import {
  CommonForm,
  Form,
  InnerContextScrollForAcademic,
  PaddingContextScrollForAcademic,
} from 'modules/RankingAlgorithm/Styles/FormStyle.js'
import {
  DomainHead,
  DomainRow,
  Note,
  SwitchPadding,
} from 'modules/RankingAlgorithm/Styles/RankingAlgorithmStyles.js'
import React, { useEffect, useState } from 'react'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import '../../../style.css'
export default function DomainIndex({
  academicName,
  domainData,
  setDomainData,
  totalValue,
  setTotalValue,
}) {
  const [form] = Form.useForm()
  // const [totalValue, setTotalValue] = useState(0)
  const [keysList, setKeysList] = useState({})
  const [functionSwitch, setFunctionSwitch] = useState({
    industry: false,
    role: false,
    function: false,
  })
  useEffect(() => {
    if (domainData) {
      setKeysList(domainData)
    }
    // //console.log(domainData, 'domaindata 4%4%')
  }, [domainData])
  useEffect(() => {
    if (keysList) {
      // //console.log(keysList, 'keysList 234')
    }
  }, [keysList])
  const onClickField = (value, index, type) => {
    let academic = keysList
    if (type) {
      academic[index][type] = value
    }
    setFunctionSwitch({
      ...functionSwitch,
      [index]: value,
    })

    let totalScores = 0

    for (const key in academic) {
      if (
        Object.prototype.hasOwnProperty.call(academic, key) &&
        academic[key].isActive
      ) {
        totalScores += Number(academic[key].score)
      }
    }
    setTotalValue(totalScores)
    setKeysList(academic)
    setDomainData(academic)
  }
  const validateInput = value => {
    const regex = /^[0-9.]*$/ // Only allow numbers and the period (.)
    return regex.test(value)
  }
  const handleKeyPress = event => {
    const data = event.target.value + event.key
    const number = 5
    if (Number(data) > number) {
      event.preventDefault()
    } else if (!validateInput(event.key)) {
      event.preventDefault() // Prevent the input from updating if it's not valid
    }
  }
  useEffect(() => {
    form.resetFields()
  }, [academicName])
  return (
    <>
      <CommonForm
        id={'uploadForm'}
        form={form}
        initialValues={{
          academic: keysList,
        }}
        key={keysList}
      >
        <InnerContextScrollForAcademic key={keysList}>
          <Row>
            <DomainRow>
              <Col span={4}>
                <DomainHead>Industry</DomainHead>
              </Col>
              <Col span={4}>
                <DomainHead>
                  <AntdInput
                    ismargin
                    name={'industry'}
                    placeholder={' Eg: 5.00'}
                    onKeyPress={handleKeyPress}
                    onChange={e =>
                      onClickField(e.target.value, 'industry', 'score')
                    }
                    defaultValue={keysList?.industry?.score}
                    height="50px"
                    width="80%"
                    borderRadius="10px"
                    disabled={!keysList?.industry?.isActive}
                    backgroundColor="#FAFAFB"
                    rules={[
                      {
                        required: true,
                        message: 'Kindly enter the data. Eg: 3.00',
                      },

                      {
                        validator: (_, value) => {
                          if (
                            value &&
                            !/^(?:[1-5](?:\.\d{1,2})?)$/.test(value)
                          ) {
                            return Promise.reject('kindly enter the valid data')
                          }

                          return Promise.resolve()
                        },
                      },
                    ]}
                  />
                </DomainHead>
              </Col>
              <Col span={2}>
                <DomainHead>
                  {' '}
                  {keysList?.industry?.isActive ? 'Active' : 'Inactive'}
                </DomainHead>
              </Col>
              <Col span={3}>
                <SwitchPadding>
                  <Switch
                    checked={keysList?.industry?.isActive}
                    onChange={checked =>
                      onClickField(checked, 'industry', 'isActive')
                    }
                  />
                </SwitchPadding>
              </Col>
            </DomainRow>
          </Row>
          <Row>
            <DomainRow>
              <Col span={4}>
                <DomainHead>Function</DomainHead>
              </Col>
              <Col span={4}>
                <DomainHead>
                  <AntdInput
                    ismargin
                    name={'function'}
                    placeholder={' Eg: 5.00'}
                    onKeyPress={handleKeyPress}
                    onChange={e =>
                      onClickField(e.target.value, 'function', 'score')
                    }
                    defaultValue={keysList?.function?.score}
                    disabled={!keysList?.function?.isActive}
                    height="50px"
                    width="80%"
                    borderRadius="10px"
                    backgroundColor="#FAFAFB"
                    rules={[
                      {
                        required: true,
                        message: 'Kindly enter the data. Eg: 3.00',
                      },

                      {
                        validator: (_, value) => {
                          if (
                            value &&
                            !/^(?:[0-5](?:\.\d{1,2})?)$/.test(value)
                          ) {
                            return Promise.reject('kindly enter the valid data')
                          }

                          return Promise.resolve()
                        },
                      },
                    ]}
                  />
                </DomainHead>
              </Col>
              <Col span={2}>
                <DomainHead>
                  {keysList?.function?.isActive ? 'Active' : 'Inactive'}
                </DomainHead>
              </Col>
              <Col span={3}>
                <SwitchPadding>
                  <Switch
                    checked={keysList?.function?.isActive}
                    onChange={checked =>
                      onClickField(checked, 'function', 'isActive')
                    }
                  />
                </SwitchPadding>
              </Col>
            </DomainRow>
          </Row>
          <Row>
            <DomainRow>
              <Col span={4}>
                <DomainHead>Role</DomainHead>
              </Col>
              <Col span={4}>
                <DomainHead>
                  <AntdInput
                    ismargin
                    name={'role'}
                    placeholder={' Eg: 5.00'}
                    onChange={e =>
                      onClickField(e.target.value, 'role', 'score')
                    }
                    onKeyPress={handleKeyPress}
                    defaultValue={keysList?.role?.score}
                    disabled={!keysList?.role?.isActive}
                    rules={[
                      {
                        required: false,
                        message: 'Kindly enter the data. Eg: 3.00',
                      },

                      {
                        validator: (_, value) => {
                          if (
                            value &&
                            !/^(?:[1-5](?:\.\d{1,2})?)$/.test(value)
                          ) {
                            return Promise.reject('kindly enter the valid data')
                          }

                          return Promise.resolve()
                        },
                      },
                    ]}
                    height="50px"
                    width="80%"
                    borderRadius="10px"
                    backgroundColor="#FAFAFB"
                  />
                </DomainHead>
              </Col>
              <Col span={2}>
                <DomainHead>
                  {keysList?.role?.isActive ? 'Active' : 'Inactive'}
                </DomainHead>
              </Col>
              <Col span={3}>
                <SwitchPadding>
                  <Switch
                    checked={keysList?.role?.isActive}
                    onChange={checked =>
                      onClickField(checked, 'role', 'isActive')
                    }
                  />
                </SwitchPadding>
              </Col>
            </DomainRow>
          </Row>
          {/* {totalValue !== 5 && ( */}
          {totalValue > 5 && (
            <div
              style={{
                marginBottom: '2%',
                color: 'red',
                textWrap: 'nowrap',
              }}
            >
              The sum of active domain must be 5
            </div>
          )}
          <Row>
            <PaddingContextScrollForAcademic>
              <Note>
                NOTE: According to the skill match and the duration, a maximum
                score is 5.
              </Note>
            </PaddingContextScrollForAcademic>
          </Row>
        </InnerContextScrollForAcademic>
      </CommonForm>
    </>
  )
}
